import React from 'react';
import { cn } from '@/lib/utils';

export interface KeyValueRow {
  label: string;
  value: React.ReactNode;
}

/**
 * Label/value rows (Figma "KV row"), separated by dividers. `flush` drops the line above the first
 * row (for a card that starts with the list); `plain` drops every line.
 */
const KeyValueList: React.FC<{ rows: KeyValueRow[]; plain?: boolean; flush?: boolean; className?: string }> = ({ rows, plain, flush, className }) => (
  <dl
    className={cn(
      'tw-flex tw-flex-col',
      !plain && 'tw-divide-y tw-divide-ds-border-default',
      !plain && !flush && 'tw-border-t tw-border-ds-border-default',
      className,
    )}
  >
    {rows.map((row) => (
      <div key={row.label} className="tw-flex tw-items-start tw-gap-4 tw-py-3 tw-text-[14px] tw-leading-5">
        <dt className="tw-w-[120px] tw-shrink-0 tw-text-ds-text-secondary">{row.label}</dt>
        <dd className="tw-min-w-0 tw-flex-1 tw-font-medium tw-text-ds-text-primary [overflow-wrap:anywhere]">{row.value}</dd>
      </div>
    ))}
  </dl>
);

export default KeyValueList;
